import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import { TextField, TextArea, CheckBox } from 'common/components/forms';
import { feedback } from 'redux/forms/actions';

import FeedbackFormSuccess from './FeedbackFormSuccess';
import { validateSubmit } from './validators';

class FeedbackForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      formSumbitted: false
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    data.email = data.feedbackEmail;
    delete data.feedbackEmail;

    data.formUrl = window.location.href;

    const successFunction = () => {
      this.setState({
        formSumbitted: true
      });
    };
    const failFunction = () => {
      this.setState({
        error: 'Unfortunately there was an error sending your feedback.'
      });
    };
    props.feedback(data, successFunction, failFunction);
  };

  render() {
    const { state, props } = this;
    const { handleSubmit } = props;

    if (!state.formSumbitted) {
      return (
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <p>We love to hear from you! What would you like to share?</p>
          <div className="c7-form__group">
            {commentTypeOptionArray().map((item) => (
              <Field
                name={item}
                label={item}
                key={item}
                className="c7-checkbox"
                component={CheckBox}
                formType="checkbox"
              />
            ))}
          </div>
          <Field
            name="comments"
            component={TextArea}
            label="Comments"
            rows={4}
            placeholder="Please enter your comments here"
            required
          />
          <Field
            name="feedbackEmail"
            component={TextField}
            label="Email"
            autocomplete="email"
            required
          />
          <div className="c7-form__button-row">
            <button type="submit" className="c7-button">
              Submit
            </button>
          </div>
          {state.error && (
            <span className="c7-message--error">Error: {state.error}</span>
          )}
        </Form>
      );
    }

    return <FeedbackFormSuccess />;
  }
}

const commentTypeOptionArray = () => [
  'Suggestion',
  'Question',
  'Like',
  'Dislike'
];

const transformData = (values) => {
  const data = {
    feedbackEmail: values.feedbackEmail,
    comments: values.comments,
    isSuggestion: values.Suggestion,
    isQuestion: values.Question,
    isLike: values.Like,
    isDislike: values.Dislike
  };

  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateSubmit(data);
  return errors;
};

FeedbackForm = reduxForm({
  form: 'FeedbackForm',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(FeedbackForm);

export default connect(null, {
  feedback
})(FeedbackForm);
